import React, { useState } from 'react';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import './Buy.css';
import { SERVER_URL } from './config';
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import LocationSearch from "./LocationSearch";


const Buy = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate(); // Initialize the navigate function
  const packege = searchParams.get('packege');
  const [paymentApproved, setPaymentApproved] = useState(false);
  const cost = packege === 'premium' ? 600 : packege === 'medium' ? 400 : 250;
  const [showPayPal, setShowPayPal] = useState(false);
  const [image, setImage] = useState(null); // New state for uploaded image
  const [customInvitationUrl, setCustomInvitationUrl] = useState(''); // URL for the uploaded image
  const [termsAccepted, setTermsAccepted] = useState(false); // State for terms acceptance
  const [couponCode, setCouponCode] = useState('');
  const [discount, setDiscount] = useState(0); // Store the discount
  const [showPopup, setShowPopup] = useState(false);
  const [loading, setLoading] = useState(false);





  const handlePopupChoice = async (choice) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      willMariageCame: choice === "yes", // Converts to a boolean
    }));
    setShowPopup(false); 
    if (!couponCode.trim()) {
      setShowPayPal(true);
    } else {
      await handleCouponSubmit();
    }
  };
  
  

  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    brideName: '',
    groomName: '',
    hall: '',
    address: '',
    latitude: null,
    longitude: null,
    date: '',
    time: '',
    phone: '',
    invitation: 'https://mariage123.s3.eu-central-1.amazonaws.com/image1.png', // Default invitation
    email: '',
    password: '',
    type: packege,
    extraRecords: 0,
    willMariageCame: false, // New field
    discountPercentage: 0,
  });

  const handleLocationSelect = (location) => {
    setFormData((prev) => ({
      ...prev,
      latitude: parseFloat(location.lat.toFixed(6)), // Round to 6 decimal places
      longitude: parseFloat(location.lng.toFixed(6)),
      address: location.name, // Save the address separately
    }));
  };
  
  const checkEmailExists = async (email) => {
    try {
      const response = await axios.get(`${SERVER_URL}check_email/`, { params: { email } });
      return response.data.exists; // Will be true or false
    } catch (error) {
      console.error('Error checking email:', error);
      alert('האימייל כבר קיים במערכת, אנא נסה שנית');
      return true; // Assume email exists in case of error to prevent payment issues
    }
  };
  

  const handleChange = (e) => {
    const { name, type, checked, value } = e.target;
    setFormData({ 
      ...formData,
      [name]: name === "willMariageCame" ? checked : 
               name === "extraRecords" ? Number(value) : value,
    });
  };
  
  

  const validateForm = () => {
    const { email, password, phone } = formData;

    // Check if all fields are filled
    for (const key in formData) {
      if (key !== 'invitation' && formData[key] === '') {
        alert('כל השדות חייבים להיות מלאים');
        return false;
      }
    }

    if (!termsAccepted) {
      alert('עליך לאשר את תנאי השימוש ואת מדיניות הפרטיות');
      return false;
    }

    // Validate password
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/;
    if (!passwordRegex.test(password)) {
      alert('הסיסמא צריכה להיות באורך שמונה תווים לפחות ולהכיל לפחות אות אחת גדולה, אות אחת קטנה, ומספר');
      return false;
    }

    // Validate email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      alert('נא להקליד כתובת אימייל תקינה');
      return false;
    }

    // Validate phone number
    const phoneRegex = /^\d{10}$/;
    if (!phoneRegex.test(phone)) {
      alert('על מספר הטלפון לכלול 10 מספרים בלבד');
      return false;
    }

    return true;
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
  
    // 1. שמירה של ה־File עצמו ל־state
    setImage(file);
  
    // 2. יצירת URL רק לתצוגת פריוויו
    const previewUrl = URL.createObjectURL(file);
    setCustomInvitationUrl(previewUrl);
  };
  


  const uploadImageToS3 = async () => {
    console.log('Upload start');
    if (!image) {
        alert('Please select an image to upload.');
        return '';
    }

    const formData = new FormData();
    formData.append('file', image);

    try {
        const response = await axios.post(`${SERVER_URL}upload/`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: `Token ${localStorage.getItem('token')}`, // Add token for authentication
            },
        });

        const imageUrl = response.data.url; // URL of the uploaded image
        setCustomInvitationUrl(imageUrl); // Set the custom invitation URL
        setFormData((prevFormData) => ({
            ...prevFormData,
            invitation: imageUrl, // Automatically set the uploaded image as the active invitation
        }));
        return imageUrl;
    } catch (error) {
        console.error('Image upload failed:', error);
        alert('Image upload failed. Please try again.');
        return '';
    }
};


const handleSignup = async (appliedDiscount) => {
  try {
    const updatedFormData = { 
      ...formData, 
      discountPercentage: appliedDiscount, // Use passed discount value
    };

    const response = await axios.post(SERVER_URL + 'signup/', updatedFormData);
    alert('ההרשמה הסתיימה בהצלחה!');
    console.log('coupon', discount)
    navigate('/login'); 
  } catch (error) {
    console.error('Signup error:', error.response?.data || error.message);
    alert('Signup failed. Please contact support.');
  }
};


const handleCouponSubmit = async () => {
  if (couponCode.trim() !== '') {  
    try {
      const response = await axios.get(`${SERVER_URL}validate_coupon`, {
        params: { name: couponCode }, // Send the coupon name as a query param
      });

      if (response.data.sale) {
        const salePercentage = response.data.sale;

        // Update discount first
        setDiscount(salePercentage);
  

        // Wait for React state to update (force synchronous execution)
        setTimeout(() => {
          // Ensure we are using the most up-to-date state
          setFormData((prevFormData) => {
            const totalCost = cost + prevFormData.extraRecords + (prevFormData.willMariageCame ? 1000 : 0);
            const newDiscountedCost = totalCost - (totalCost * (salePercentage / 100));
            setFormData((prevFormData) => ({
              ...prevFormData,
              discountPercentage: salePercentage,
            }));

            alert(`✅ קוד קופון אומת! ההנחה שלך היא ${salePercentage}%.`);
            console.log(`✅ Updated Discount: ${salePercentage}%`);
            console.log(`✅ New Discounted Cost: ${newDiscountedCost}`);

            // If discount is 100%, complete the process immediately
            if (salePercentage === 100) {
              alert('🎉 המחיר לאחר ההנחה הוא 0 ₪, התשלום לא נדרש.');
              handlePaymentSuccess(salePercentage); // Pass discount directly
            } else {
              setShowPayPal(true);
            }

            return prevFormData; // Ensure formData is preserved
          });
        }, 0); // Delay by 0ms to ensure React updates the state first
      }
    } catch (error) {
      console.error('❌ Error validating coupon:', error);
      alert('⚠️ קוד קופון זה לא זמין, אנא נסו שנית');
    }
  }
};

const handlePaymentSuccess = async (appliedDiscount) => {
  setLoading(true); // הצגת הפופאפ


  try {
    if (couponCode) {
      await axios.post(`${SERVER_URL}use_coupon`, {
        name: couponCode,
      });
    }

    setPaymentApproved(true);
    setShowPayPal(false);

    handleSignup(appliedDiscount); // Pass discount explicitly
  } catch (error) {
    console.error('Error using coupon:', error);
    alert('❌ שגיאה בסיום התהליך. אנא פנו לתמיכה.');
  } finally {
    setLoading(false);
}
};
 

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) return; // Validate form fields
    
    // **Check if the email already exists**
    const emailExists = await checkEmailExists(formData.email);
    if (emailExists) {
      alert('האימייל כבר רשום במערכת. אנא השתמש באימייל אחר.');
      return;
    }
    
    // **Validate image size before uploading**
    if (image) {
      const maxSize = 2 * 1024 * 1024; // 2MB limit
      if (image.size > maxSize) {
        alert('גודל הקובץ גדול מדי. אנא בחר תמונה קטנה מ-2MB.');
        return;
      }
  
      const imageUrl = await uploadImageToS3();
      if (!imageUrl) {
        alert('העלאת התמונה נכשלה. נא לנסות שוב.');
        return;
      }
    
      // שומרת את ה-URL שקיבלת מהשרת בשדה invitation
      setFormData((prev) => ({
        ...prev,
        invitation: imageUrl,
      }));
    }

    if (!formData.willMariageCame) {
      setShowPopup(true);
      return;
    }

    if (!couponCode.trim()) {
      setShowPayPal(true);
    } else {
      await handleCouponSubmit();
    }
  };

  return (
    <div className="background">
      <div className="buy-container">
        <h1>פרטים אישיים והרשמה</h1>
        <p className="invitation-text">
      ניתן לשנות את כל הפרטים בכל שלב לאחר ההרשמה
            </p>
        <form onSubmit={handleSubmit}>
          <label>
            שם פרטי:
            <input
              type="text"
              name="firstName"
              value={formData.firstName}
              onChange={handleChange}
              required
            />
          </label>
          <label>
            שם משפחה:
            <input
              type="text"
              name="lastName"
              value={formData.lastName}
              onChange={handleChange}
              required
            />
          </label>
          <label>
            שם הכלה:
            <input
              type="text"
              name="brideName"
              value={formData.brideName}
              onChange={handleChange}
              required
            />
          </label>
          <label>
            שם החתן:
            <input
              type="text"
              name="groomName"
              value={formData.groomName}
              onChange={handleChange}
              required
            />
          </label>
          <label>
            כתובת אולם:
            <LocationSearch onLocationSelect={handleLocationSelect} />
          </label>
          <label>
            שם האולם:
            <input
              type="text"
              name="hall"
              value={formData.hall}
              onChange={handleChange}
              required
            />
          </label>
          <label>
            תאריך האירוע:
            <input
              type="date"
              name="date"
              value={formData.date}
              onChange={handleChange}
              required
            />
          </label>
          <label>
            שעת האירוע:
            <input
              type="time"
              name="time"
              value={formData.time}
              onChange={handleChange}
              required
            />
          </label>
          <label>
            מספר טלפון:
            <input
              type="text"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              required
            />
          </label>
          <div>
          <p className="invitation-text">
             בחירת הזמנה (תמונה זו תישלח למוזמנים ביחד עם פרטי האירוע):
            </p>
            <div className="invitation-options">
    {/* First Image */}
    <div className={`invitation-option ${formData.invitation === 'https://mariage1234.s3.eu-central-1.amazonaws.com/image1.jpeg' ? 'selected' : ''}`}>
        <input
            type="radio"
            name="invitation"
            value="https://mariage1234.s3.eu-central-1.amazonaws.com/image1.jpeg"
            checked={formData.invitation === 'https://mariage1234.s3.eu-central-1.amazonaws.com/image1.jpeg'}
            onChange={handleChange}
        />
        <img 
            src="image1.png" 
            alt="Invitation 1"
            onClick={() => setFormData({ ...formData, invitation: 'https://mariage1234.s3.eu-central-1.amazonaws.com/image1.jpeg' })}
        />
    </div>

    {/* Second Image */}
    <div className={`invitation-option ${formData.invitation === 'https://mariage1234.s3.eu-central-1.amazonaws.com/image2.jpeg' ? 'selected' : ''}`}>
        <input
            type="radio"
            name="invitation"
            value="https://mariage1234.s3.eu-central-1.amazonaws.com/image2.jpeg"
            checked={formData.invitation === 'https://mariage1234.s3.eu-central-1.amazonaws.com/image2.jpeg'}
            onChange={handleChange}
        />
        <img 
            src="image2.png" 
            alt="Invitation 2"
            onClick={() => setFormData({ ...formData, invitation: 'https://mariage1234.s3.eu-central-1.amazonaws.com/image2.jpeg' })}
        />
    </div>

    {/* Third Image */}
    <div className={`invitation-option ${formData.invitation === 'https://mariage1234.s3.eu-central-1.amazonaws.com/image3.jpeg' ? 'selected' : ''}`}>
        <input
            type="radio"
            name="invitation"
            value="https://mariage1234.s3.eu-central-1.amazonaws.com/image3.jpeg"
            checked={formData.invitation === 'https://mariage1234.s3.eu-central-1.amazonaws.com/image3.jpeg'}
            onChange={handleChange}
        />
        <img 
            src="image3.png" 
            alt="Invitation 3"
            onClick={() => setFormData({ ...formData, invitation: 'https://mariage1234.s3.eu-central-1.amazonaws.com/image3.jpeg' })}
        />
    </div>

{/* Upload a Custom Image */}
<div className={`upload-option ${formData.invitation === customInvitationUrl ? 'selected' : ''}`}>
    {/* Radio Button (Positioned Above) */}
    <input
        type="radio"
        name="invitation"
        value={customInvitationUrl}
        checked={formData.invitation === customInvitationUrl}
        onChange={() => setFormData({ ...formData, invitation: customInvitationUrl })}
    />

    {/* File Input (Hidden but Clickable) */}
    <input 
        type="file" 
        accept="image/*" 
        id="fileUpload"
        onChange={handleImageChange} 
    />

    {/* Bigger and Bolder Upload Label */}
    {!customInvitationUrl && (
        <label htmlFor="fileUpload">העלה תמונה משלך</label>
    )}

    {/* Show Preview if Image is Uploaded */}
    {customInvitationUrl && (
        <div className="image-preview">
            <img src={customInvitationUrl} alt="Preview" />
        </div>
    )}
</div>
</div>
          </div>
          <label>
            קוד קופון:
            <input type="text" value={couponCode} onChange={(e) => setCouponCode(e.target.value)} placeholder="הכנס קוד קופון" />
          </label>
          <label>
        רשומות נוספות (שקל לרשומה):
        <input
          type="number"
          name="extraRecords"
          value={formData.extraRecords}
          onChange={handleChange}
          min="0"
        />
          </label>
<div className="terms">
            <label>
            <input
    type="checkbox"
    name="willMariageCame"
    checked={formData.willMariageCame}
    onChange={handleChange}
  />
              <span>
              צוות מריאז מגיעים לאולם (תוספת 1,000₪)
              </span>
            </label>
          </div>

          <label>
            אימייל:
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </label>
          <label>
            יצירת סיסמא:
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
            />
          </label>

          <div className="terms">
            <label>
              <input
                type="checkbox"
                checked={termsAccepted}
                onChange={() => setTermsAccepted(!termsAccepted)}
              />
              <span>
                אני מאשר את <Link to="/useterms">תנאי השימוש</Link> ואת <Link to="/privacy">מדיניות הפרטיות</Link>
              </span>
            </label>
          </div>

          <button type="submit">המשך לתשלום</button>
          {loading && (
    <div className="loading-overlay">
        <div className="loading-popup">
            ⏳ מעבד נתונים... ההרשמה שלך בעיבוד, נא להמתין
        </div>
    </div>
)}
        </form>
        {showPopup && (
  <div className="popup-overlay">
    <div className="popup-box">
      <h2>ראינו שלא סימנת שצוות מריאז יגיע לאולם</h2>
      <p>במחיר של 1,000 שח בלבד אתה מקבל שני אנשי צוות מקצועיים<br />
        שיגיעו לפני האירוע ויישארו איתך עד שאחרון האורחים ידע איפה הוא יושב
      </p>
      <div className="popup-buttons">
        <br></br>
        <button className="decline-btn" onClick={() => handlePopupChoice("no")}>
          אני לא מעוניין
        </button>
        <button className="confirm-btn" onClick={() => handlePopupChoice("yes")}>
          אני אשמח שצוות מריאז יגיעו לאירוע
        </button>
      </div>
    </div>
  </div>
)}
      {showPayPal && (
        <div className="paypal-modal">
          <div className="paypal-container">
            <h2>בחר אמצעי תשלום</h2>
            <PayPalScriptProvider options={{ "client-id": "Aah8FUGK0QubZ8S-cByjK9MnMzjeWXfmbOLXjWZ9nBgU2cVbumpYnMyFqVLLtTNgETOWZZhbK0dLK_bK",
                components: "buttons,applepay",
                currency: "ILS",
                locale: "he_IL",
                intent: "capture", }}
                >
              <div className="paypal-buttons-container">
              <PayPalButtons
  createOrder={(data, actions) => {
    const appliedDiscount = formData.discountPercentage || 0; // Ensure correct discount is used
    const discountedCost = (cost + formData.extraRecords + (formData.willMariageCame ? 1000 : 0)) - 
    ((cost + formData.extraRecords + (formData.willMariageCame ? 1000 : 0)) * (appliedDiscount / 100));

    return actions.order.create({
      purchase_units: [
        {
          amount: {
            currency_code: "ILS",
            value: discountedCost.toFixed(2), // Apply discount here
          },
        },
      ],
    });
  }}
  onApprove={(data, actions) => {
    return actions.order.capture().then((details) => {
      console.log("Payment Successful:", details);
      handlePaymentSuccess(formData.discountPercentage); // Pass discount explicitly
    });
  }}
  onError={(err) => {
    console.error("PayPal Payment Error:", err);
    alert('Payment failed. Please try again.');
    setShowPayPal(false);
  }}
/>
              </div>
            </PayPalScriptProvider>
            <button className="close-modal" onClick={() => setShowPayPal(false)}>×</button>
          </div>
        </div>
       )}
    </div>
    </div>  
  );
};

export default Buy;   